export const VALIDATE = {
    PRICE : /^\d*\.?\d{0,2}$/,
    EMPTY: /^.+$/,
    NUMBER: /^\d+$/,
    ALPHANUMERIC: /^[a-zA-Z0-9]+$/,
    SHORT_DATE: /^$|^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{2}$/,
    MAX: (e) => { return new RegExp(`^.{0,${e}}$`); },
    MIN: (e) => { return new RegExp(`^.{${e},}$`); },
    DATE: /^(?:(\d{2})(\d{2})(\d{2}))|(?:\d{4})|(?:\d{6})|(?:\d{8})|(?:\d{10})$/,
    CHARS: (_a, _allow_empty) => {
        const _s = _a.map(c => c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('');
        if (_allow_empty) {
            return new RegExp(`^[${_s}]*$`);
        } else {
            return new RegExp(`^[${_s}]$`);
        }
    },
    ENUM: (enumArray) => {
        const escapedValues = enumArray.map(value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
        return new RegExp(`^(${escapedValues})$`);
    },
    RANGE: (min, max) => {
        return new RegExp(`^(${min}|[1-9]\\d{0,${max.toString().length - 1}}|${max})$`);
    }
}


export const CHARSETS = {
    SHORT_DATE : ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "/"]
}